import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { rem2px, REM_CONFIG } from "@/utils/fontSize";
import MaterialArrivalRight from "@/assets/img/cpm/material-arrival-right.png";
import Batch from "@/assets/img/cpm/batch.png";
import Beight from "@/assets/img/cpm/weight.png";
// 默认模拟数据
const defaultMaterialData = {
    manufacturingCycle: 30,
    pieData: [
        { name: "木质素", value: 13 },
        { name: "萘系聚合物", value: 23 },
        { name: "水", value: 64 },
    ],
    dailyProductionTimes: 4,
    orderTonnage: 23,
};
const QualityControl = ({ className = "", data, }) => {
    const [materialData, setMaterialData] = useState(data || defaultMaterialData);
    const chartRef = useRef(null);
    // 模拟接口请求
    useEffect(() => {
        if (data)
            return;
        const fetchMaterialData = async () => {
            const mockResponse = await new Promise((resolve) => {
                setTimeout(() => resolve(defaultMaterialData), 500);
            });
            setMaterialData(mockResponse);
        };
        fetchMaterialData();
    }, [data]);
    // 饼图配置选项（添加ECharts自带图例，使用rem2px处理）
    const getPieOption = useCallback(() => ({
        // ECharts自带图例配置，使用rem2px处理尺寸
        legend: {
            orient: "horizontal", // 水平排列
            bottom: 0, // 显示在饼图底部
            left: 0,
            textStyle: {
                color: "white", // 图例文字颜色
                fontSize: REM_CONFIG.fontSize.small, // 使用rem2px处理
            },
            itemWidth: rem2px(0.11), // 使用rem2px处理
            itemHeight: rem2px(0.11), // 使用rem2px处理
            itemGap: rem2px(0.04), // 使用rem2px处理
            data: materialData.pieData.map((item) => item.name), // 绑定图例数据
        },
        color: ["#00FFFF", "#FF7F50", "#1E90FF"], // 对应“木质素（青）、干粉（橙）、水（蓝）”
        series: [
            {
                type: "pie",
                radius: ["30%", "64%"], // 环形饼图
                center: ["40%", "40%"], // 调整饼图位置（上移，给底部图例留空间）
                data: materialData.pieData,
                label: {
                    show: true,
                    formatter: "{c}%", // 显示百分比
                    color: "white",
                    position: "inside",
                    fontSize: REM_CONFIG.fontSize.small, // 使用rem2px处理
                },
                labelLine: { show: false }, // 隐藏标签连线
            },
        ],
        tooltip: {
            trigger: "item",
            // formatter: "{b}: {c}%",
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small, // 使用rem2px处理
            },
        },
    }), [materialData]);
    // 监听根元素字体大小变化，更新ECharts配置
    useEffect(() => {
        const observer = new ResizeObserver(() => {
            if (chartRef.current) {
                chartRef.current.getEchartsInstance().setOption(getPieOption());
            }
        });
        if (document.documentElement) {
            observer.observe(document.documentElement);
        }
        return () => observer.disconnect();
    }, [getPieOption]);
    // 窗口大小变化时重绘图表
    useEffect(() => {
        const handleResize = () => {
            if (chartRef.current) {
                chartRef.current.getEchartsInstance().resize();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (_jsxs("div", { className: `relative bg-gradient-to-t from-[rgba(7,31,75,0.5)] to-[rgba(6,32,66,0.2)]  flex flex-col ${className} min-h-0`, children: [_jsx(ModuleHeader, { title: "\u539F\u6599\u7C7B\u578B" }), _jsxs("div", { className: "flex-1 w-full h-full flex items-center justify-between min-h-0", children: [_jsxs("div", { className: "flex items-center h-full min-h-0", children: [_jsx("div", { className: "w-[1.70rem] h-full", children: _jsx(ReactEcharts, { ref: chartRef, option: getPieOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) }), _jsxs("div", { className: "flex flex-col", children: [_jsxs("div", { className: "flex items-center", children: [_jsx("img", { src: Batch, style: {
                                                    width: "0.68rem",
                                                    height: "0.52rem",
                                                    maxHeight: "100%",
                                                    maxWidth: "100%",
                                                    objectFit: "cover", // 保持图片比例，覆盖整个容器（避免拉伸变形）
                                                    objectPosition: "center", // 图片居中显示
                                                }, alt: "batch icon" }), _jsxs("div", { className: "flex flex-col", children: [_jsx("span", { className: "text-[0.12rem] text-white", children: "\u65E5\u5747\u751F\u4EA7\u6279\u6B21" }), _jsx("span", { className: "text-[0.32rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: materialData.dailyProductionTimes })] })] }), _jsxs("div", { className: "flex items-center", children: [_jsx("img", { src: Beight, alt: "weight icon", style: {
                                                    width: "0.68rem",
                                                    height: "0.52rem",
                                                    maxHeight: "100%",
                                                    maxWidth: "100%",
                                                    objectFit: "cover", // 保持图片比例，覆盖整个容器（避免拉伸变形）
                                                    objectPosition: "center", // 图片居中显示
                                                } }), _jsxs("div", { className: "flex flex-col", children: [_jsx("span", { className: "text-[0.12em] text-white", children: "\u8BA2\u5355\u4E2D\u5428\u6570" }), _jsx("span", { className: "text-[0.32rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: materialData.orderTonnage })] })] })] })] }), _jsxs("div", { className: "relative", children: [_jsx("img", { src: MaterialArrivalRight, style: {
                                    width: "1.29rem",
                                    height: "1.29rem",
                                    maxHeight: "100%",
                                    maxWidth: "100%",
                                    objectFit: "cover", // 保持图片比例，覆盖整个容器（避免拉伸变形）
                                    objectPosition: "center", // 图片居中显示
                                }, alt: "\u53F3\u4FA7\u5706\u5F62\u80CC\u666F\u56FE" }), _jsxs("div", { className: "absolute inset-0 flex flex-col items-center justify-center ", children: [_jsx("span", { className: "text-[0.12rem] text-white", children: "\u5236\u9020\u5468\u671F" }), _jsx("span", { className: "text-[0.38rem] font-bold bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent", children: materialData.manufacturingCycle }), _jsx("span", { className: "text-[0.12rem] text-white", children: "(min)" })] })] })] })] }));
};
export default QualityControl;
